<div class="payment container">
  <h2 class="payment-title title">
    {{ 'paymentForm.title' | translate }}
  </h2>
  <form [formGroup]="form" class="payment-form form-container">
    <!-- Card Number Field -->
    <div class="form-field" [ngClass]="{'field-invalid': showPanError}">
      <label for="pan" class="form-label">
        {{ 'application.cardNumber' | translate }}
      </label>
      <input id="pan" type="text" formControlName="pan" class="form-input" appPanFormatter [useSpaces]="($panFormatting | async) ?? true" [attr.placeholder]="($placeholders | async) ? (($panFormatting | async) !== false ? '1234 5678 9123 4567' : '1234567891234567') : null"/>
    </div>

    <!-- Expiration date fields -->
    <div class="form-field" [ngClass]="{'field-invalid': showExpirationError}">
      <!-- eslint-disable-next-line -->
      <label class="form-label">
        {{ 'paymentForm.expDate' | translate }}
      </label>
      <div class="expiration-fields">
        <input id="expDateMonth" type="text" maxlength="2" formControlName="expDateMonth" class="form-input form-input-exp form-input-exp-month" #expDateMonthInput appAutoFocusTransition [next]="expDateYearInput" [attr.placeholder]="($placeholders | async) ? '09' : null"/>
        <span class="expiration-separator">/</span>
        <input id="expDateYear" type="text" maxlength="2" formControlName="expDateYear" class="form-input form-input-exp form-input-exp-year" #expDateYearInput appAutoFocusTransition [prev]="expDateMonthInput" [attr.placeholder]="($placeholders | async) ? '28' : null"/>
      </div>
    </div>
  
    <!-- Card Owner Name Field -->
    <div class="form-field" [ngClass]="{'field-invalid': showNameError}">
      <label for="cardOwnerName" class="form-label">
        {{ 'paymentForm.cardownerName' | translate }}
      </label>
      <input id="cardOwnerName" type="text" formControlName="cardOwnerName" class="form-input" appNameSanitizer [attr.placeholder]="($placeholders | async) ? 'John Doe' : null"/>
    </div>

    <!-- CVV2 Field -->
    <div class="form-field" [ngClass]="{'field-invalid': showCvv2Error}">
      <label for="cvv2" class="form-label">
        {{ 'paymentForm.cvv2' | translate }}
      </label>
      <input id="cvv2" type="text" formControlName="cvv2" class="form-input" [attr.placeholder]="($placeholders | async) ? '137' : null"/>
    </div>

    <!-- Store checkbox -->
    <div class="form-checkbox">
      <label for="register" class="form-label">
        <input id="register" type="checkbox" formControlName="register" class="form-input"/>
        {{ 'paymentForm.storeCardData' | translate }}
      </label>
    </div>
  </form>
  
  <!-- Submit Button -->
  <button
    type="button"
    [disabled]="($permissiveSubmitButton | async) ? ($isSubmitEnabled | async) === false : !form.valid || ($isSubmitEnabled | async) === false"
    (click)="onSubmit()"
    class="form-button"
  >
    {{ 'paymentForm.pay' | translate }}
  </button>
  
  <div class="form-errors">
    @if (showPanError && fc.pan.missing) {
      <div class="error-message">{{ 'paymentForm.cardNumberRequired' | translate }}</div>
    } @else if (showPanError && fc.pan.tooShort) {
      <div class="error-message">
        {{ 'panTokenGeneration.cardNumberTooShort' | translate }}
      </div>
    } @else if (showPanError && fc.pan.tooLong) {
      <div class="error-message">
        {{ 'panTokenGeneration.cardNumberTooLong' | translate }}
      </div>
    } @else if (showPanError && fc.pan.luhnInvalid) {
      <div class="error-message">{{ 'paymentForm.wrongCardNumber' | translate }}</div>
    }
    
    @if (showExpirationError && fc.expDateMonth.missing) {
      <div class="error-message">{{ 'paymentForm.expDateMonthRequired' | translate }}</div>
    } @else if (showExpirationError && fc.expDateMonth.badFormat) {
      <div class="error-message">{{ 'paymentForm.wrongExpMonth' | translate }}</div>
    }
    
    @if (showExpirationError && fc.expDateYear.missing) {
      <div class="error-message">{{ 'paymentForm.expDateYearRequired' | translate }}</div>
    } @else if (showExpirationError && fc.expDateYear.patternFail) {
      <div class="error-message">{{ 'paymentForm.wrongExpYear' | translate }}</div>
    }
    
    @if (expirationDateInPast) {
      <div class="error-message">{{ 'paymentForm.expInPast' | translate }}</div>
    }  
    
    @if (showNameError && fc.cardOwnerName.missing) {
      <div class="error-message">{{ 'paymentForm.cardOwnerNameRequired' | translate }}</div>
    }
    
    @if (showCvv2Error && fc.cvv2.missing) {
      <div class="error-message">{{ 'paymentForm.cvv2Required' | translate }}</div>
    } @else if (showCvv2Error && fc.cvv2.patternFail) {
      <div class="error-message">{{ 'paymentForm.wrongCvv2' | translate }}</div>
    }
  </div>
</div>
